import { Link } from "wouter";
import { ClipboardList, Compass, Factory, Truck } from "lucide-react";

const ROUTES_BACK = [
  { href: "/", label: "今日工作台", icon: Factory },
  { href: "/manage/orders", label: "訂單管理", icon: ClipboardList },
  { href: "/manage/logistics", label: "物流簽收", icon: Truck },
] as const;

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-canvas p-4 text-ink">
      <div className="w-full max-w-md rounded-md border border-line bg-surface/70 p-6">
        <div className="flex items-center gap-3">
          <Compass className="h-8 w-8 text-ink-muted" aria-hidden="true" />
          <div>
            <h1 className="text-xl font-bold text-ink-strong">找不到這個頁面</h1>
            <p className="mt-1 text-sm text-ink-muted">
              網址可能已變更或不存在。試試以下常用入口：
            </p>
          </div>
        </div>

        <nav aria-label="常用入口" className="mt-5 flex flex-col gap-2">
          {ROUTES_BACK.map(({ href, label, icon: Icon }) => (
            <Link
              key={href}
              href={href}
              className="flex items-center gap-3 rounded-md border border-line bg-canvas px-3 py-2.5 text-sm text-ink transition-colors hover:border-line-strong hover:text-ink"
            >
              <Icon className="h-4 w-4 text-progress" aria-hidden="true" />
              {label}
              <span className="ml-auto font-mono text-xs text-ink-muted">{href}</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
}
